import React, { memo } from 'react';
import { WarrantyConditions } from 'site-modules/shared/components/inventory/warranty-module/warranty-item/warranty-conditions/warranty-conditions';
import { WarrantyComments } from 'site-modules/shared/components/inventory/warranty-module/warranty-item/warranty-comments/warranty-comments';
import { WARRANTY_TYPE } from 'site-modules/shared/constants/inventory/warranty';
import { AccordionItem } from 'site-modules/shared/components/inventory/accordion/accordion-item/accordion-item';
import { InventoryEntities } from 'client/data/models/inventory';

import './warranty-item.scss';

const WARRANTY_TYPE_ICON = {
  [WARRANTY_TYPE.EV_BATTERY]: <i className="icon-leaf ms-0_5" aria-hidden />,
};

export const WarrantyItem = memo(props => {
  const { warrantyItem } = props;

  const { id, warrantyType } = warrantyItem;

  return (
    <li className="warranty-item">
      <AccordionItem
        id={`details-${id}`}
        summary={
          <div className="d-flex text-cool-gray-40 me-1 py-1">
            <h3 className="warranty-item-type fw-bold size-16 m-0">
              {warrantyType}
              {WARRANTY_TYPE_ICON[warrantyType]}
            </h3>
            <WarrantyConditions className="warranty-item-conditions ms-1" warrantyItem={warrantyItem} />
          </div>
        }
        trackingValue={warrantyType}
      >
        <div className="mb-1">
          <WarrantyComments warrantyItem={warrantyItem} />
        </div>
      </AccordionItem>
    </li>
  );
});

WarrantyItem.propsTypes = {
  warrantyItem: InventoryEntities.WarrantyItem.isRequired,
};

WarrantyItem.displayName = 'WarrantyItem';
